import { pdf } from '@react-pdf/renderer'
import type React from 'react'

import { PDF_FONTS, type PdfFontSet, pdfFontsFor } from './pdfFonts'
import { withArtifactPdfHyphenation } from './pdfHyphenation'

/** A kind's PDF: the element to render on a font set, and every string that reaches the page. */
export interface ArtifactPdfSource {
  text: string
  element: (fonts: PdfFontSet) => React.ReactElement
}

/**
 * Renders with Helvetica, switching to the Unicode font only when the printed
 * text needs it and falling back to Helvetica if that font cannot be loaded;
 * the hyphenation callback is installed only while rendering.
 */
export async function renderArtifactPdf<T>(
  source: ArtifactPdfSource,
  render: (element: React.ReactElement) => Promise<T>
): Promise<T> {
  return await withArtifactPdfHyphenation(async () => {
    const fonts = pdfFontsFor(source.text)
    try {
      return await render(source.element(fonts))
    } catch (error) {
      if (fonts === PDF_FONTS.helvetica) throw error
      return await render(source.element(PDF_FONTS.helvetica))
    }
  })
}

export async function renderArtifactPdfBlob(
  source: ArtifactPdfSource
): Promise<Blob> {
  return await renderArtifactPdf(source, (element) => pdf(element).toBlob())
}
